<div>
  <ng-container *ngIf="!displayTableOnly">
    <div class="title-container">
      <div class="payment-detail-contents">
        <span class="content-heading">Payment Details</span>
      </div>
    </div>
    <div *ngIf="invoice.paymentType === 'Check' && isConfirmationPage" class="contents-warning">
      <mat-icon class="warning-icon md-24">warning</mat-icon>
      <span class="warning-content">Action Required</span>
    </div>
    <div class="contents">
      <span class="content-title">{{ transactionDateLabel }}</span>
      <span>{{ invoice.transactionDate }}</span>
    </div>
    <div class="contents" *ngIf="!invoice.paymentType">
      <span class="content-title">Invoice Number</span>
      <span>{{ invoice.invoiceNumber }}</span>
    </div>
    <div class="contents" *ngIf="!invoice.paymentType">
      <span class="content-title">Due Date</span>
      <span>{{ invoice.dueDate }}</span>
    </div>
    <div class="contents">
      <span class="content-title">{{ orderNumberLabel }}</span>
      <span>{{ invoice.orderNumber }}</span>
    </div>
    <div class="contents" *ngIf="invoice.paymentType">
      <span class="content-title">Payment Type</span>
      <span>{{ invoice.paymentTypeDisplay }}</span>
    </div>
  </ng-container>

  <div *ngFor="let item of invoice.paymentInvoiceLineItems">
    <div class="table-rows">
      <span>{{ item.label }}</span>
      <span>{{ item.amount | currency }}</span>
    </div>
  </div>
  <div class="payment-line-total" fxLayout *ngIf="getTotalDisplay() as totalDisplay">
    <div>{{ totalDisplay.label }}</div>
    <div>{{ totalDisplay.amount | currency }}</div>
  </div>
  <div *ngIf="invoice.paymentType === 'Check' && isConfirmationPage">
    <div class="contents-warning instructions">
      <mat-icon class="warning-icon md-24">warning</mat-icon>
      <span class="warning-content">To complete payment, follow these instructions:</span>
    </div>
    <div class="contents">
      <div [innerHTML]="checkInstructions | safeHtml"></div>
    </div>
  </div>
</div>
